export default __webpack_public_path__ + "static/media/contemporaryV2-desktop.c4a9a075.jpg";